var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkChecked = function SvgCheckmarkChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.223 39.445l-7.778 7.778 25 25L100 16.668l-7.777-7.777-47.778 47.777zM88.89 88.891H11.109V11.109h55.559V0H11.109C5 0 0 5 0 11.11v77.78C0 95 5 100 11.11 100h77.78C95 100 100 95 100 88.89V44.446H88.89zm0 0"
  })));
};
export default SvgCheckmarkChecked;